<template>
  <div>
    <nav-title />
    <div class="page">
      <div class="layout-main">
        <div class="search">
          <el-input
            class="cl-middle-font-size"
            style="width:215px;height: 32px"
            suffix-icon="el-icon-search"
            size="small"
            v-model="form.name"
            placeholder="请输入标题关键词"
          />
        </div>
        <div class="filter">
          <div class="fields">
            <div class="field">
              <multi-selecter
                :options="creativeTypeOptions"
                :value.sync="form.creative_type"
                label="广告类型"
              />
            </div>
            <div class="field">
              <multi-selecter
                :options="dspTypeOptions"
                :value.sync="form.dsp"
                label="DSP"
              />
            </div>
            <div class="field">
              <multi-selecter
                :options="sizeTypeOptions"
                :value.sync="form.size"
                label="尺寸"
              />
            </div>
            <div class="field">
              <multi-selecter
                :options="advTypeOptions"
                :value.sync="form.ftx_slot_id"
                label="广告位ID"
              />
            </div>
            <div class="field">
              <el-date-picker
                type="daterange"
                size="mini"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :value="ranges"
                @input="handleChangeDate"
                :picker-options="pickerOptions"
                style="width: 300px;height: 32px;"
              >
              </el-date-picker>
            </div>
            <el-button type="primary" @click="queryList" size="mini"
              >搜索</el-button
            >
            <el-button size="mini" @click="resetCondition">重置</el-button>
          </div>
        </div>
        <list-row :gutter="24" :width="198" v-loading="loading">
          <list-col v-for="item in list" :key="item.id">
            <div class="item">
              <div class="mask-wrap">
                <div
                  class="content"
                  v-html="getImages(item.material_info)"
                ></div>
                <div class="mask-item">
                  <div
                    class="button big"
                    @click="previewImage(item.material_info)"
                  >
                    <svg class="svg-icon" aria-hidden="true">
                      <use xlink:href="#icon-preview"></use>
                    </svg>
                  </div>
                </div>
              </div>
              <div class="info">
                <div class="size">
                  CTR:
                  {{
                    item.imp === 0
                      ? '0'
                      : ((item.clk / item.imp) * 100).toFixed(2)
                  }}%
                </div>
                <div class="name">
                  {{ getTitle(item.material_info) }}
                </div>
              </div>
            </div>
          </list-col>
        </list-row>

        <div class="pagination">
          <el-pagination
            class="cl-pagination"
            background
            layout="prev, pager, next , sizes"
            @size-change="handleSizeChange"
            @current-change="handleChangePage"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="10"
            :total="total"
            :current-page.sync="$store.state[namespace].page"
          >
          </el-pagination>
        </div>
      </div>
      <el-dialog title="预览" :visible.sync="preview">
        <div class="dialog">
          <img
            v-for="(img, index) in images"
            :key="index"
            :src="img"
            style="width:auto;max-width:100%;max-height:500px;border:1px solid #ccc;"
          />
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import UploadSvg from 'components/UploadSvg';
import CategorySelect from 'components/CategorySelect';
import { convertJSON } from 'utils/helper';
import NavTitle from 'components/NavTitle';
import MultiSelecter from 'components/MultiSelecter';
import moment from 'moment';
import Row from 'components/List/Row';
import Col from 'components/List/Col';
import ListMixins from '../mixins/list';
import {
  CREATIVE_TYPE_OPTIONS,
  OS_TYPE_OPTIONS,
  DSP_TYPE_OPTIONS,
  SIZE_TYPE_OPTIONS,
  TEMPLATE_TYPE_OPTIONS,
  SOURCE_TYPE_OPTIONS,
  ADV_TYPE_OPTIONS
} from 'constant/material';

export default {
  name: 'TemplateList',
  mixins: [ListMixins],
  data() {
    return {
      namespace: 'material',
      preview: false,
      selection: [],
      images: [],
      ranges: [
        Date.now() - 24 * 60 * 60 * 1000,
        Date.now() - 24 * 60 * 60 * 1000
      ],
      dialogVisible: false,
      query: '',
      options: {
        multi: true
      },
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        fileContent: [{ required: true, message: '请上传模板' }]
      },
      form: {
        name: '',
        creative_type: [],
        os: [],
        dsp: [],
        size: [],
        source: '',
        ftx_slot_id: [],
        template_id: ''
      },
      creativeTypeOptions: CREATIVE_TYPE_OPTIONS,
      osTypeOptions: OS_TYPE_OPTIONS,
      dspTypeOptions: DSP_TYPE_OPTIONS,
      sizeTypeOptions: SIZE_TYPE_OPTIONS,
      templateTypeOptions: TEMPLATE_TYPE_OPTIONS,
      sourceTypeOptions: SOURCE_TYPE_OPTIONS,
      advTypeOptions: ADV_TYPE_OPTIONS,
      filterValues: {
        begin: moment(Date.now() - 24 * 60 * 60 * 1000).format('YYYY-MM-DD'),
        end: moment(Date.now() - 24 * 60 * 60 * 1000).format('YYYY-MM-DD'),
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 24 * 60 * 60 * 1000;
        }
      }
    };
  },
  watch: {
    dialogVisible(value) {
      if (!value) {
        this.form.name = '';
        this.form.tagIds = [];
        this.form.fileContent = null;
      }
    }
  },
  components: {
    'upload-svg': UploadSvg,
    'category-select': CategorySelect,
    'nav-title': NavTitle,
    'multi-selecter': MultiSelecter,
    'list-row': Row,
    'list-col': Col
  },
  computed: {
    tags() {
      return this.$store.state.tags.list || [];
    },
    currentPage() {
      return;
    }
  },
  beforeDestroy() {
    this.$store.commit('material/update', {
      condition: {},
      list: [],
      total: 0,
      page: 1,
      pageSize: 10
    });
  },
  methods: {
    getTitle(info) {
      try {
        const list = JSON.parse(info).item;
        return ((list.filter(item => item.text)[0] || {}).text || {}).text;
      } catch (e) {
        return '';
      }
    },
    previewImage(info) {
      this.images = [];
      let images = [];
      const list = JSON.parse(info).item;
      list.forEach(item => {
        if (item.image && item.type === 2) {
          images.push(item.image.url);
        }
      });
      this.images = images;
      this.preview = true;
    },
    getImages(info) {
      let html = '';
      try {
        const list = JSON.parse(info).item;
        list.forEach(item => {
          if (item.image && item.type === 2) {
            html += `<div><img src="${item.image.url}"/></div>`;
          }
        });
        return html;
      } catch (e) {
        const url = info;

        html += `<div><img src="${url}"/></div>`;

        return html;
      }
    },
    handleChangeDate(date) {
      this.ranges = date || [];
      if (date && date.length) {
        this.form.begin = moment(date[0]).format('YYYY-MM-DD');
        this.form.end = moment(date[1]).format('YYYY-MM-DD');
      } else {
        this.form.begin = null;
        this.form.end = null;
      }
    },
    limitTextHandler(text) {
      return count => `${text} (${count})`;
    },
    resetCondition() {
      this.$store.commit('material/update', {
        condition: {}
      });
      this.ranges = [];
      this.form.begin = null;
      this.form.end = null;
      this.form = {
        name: '',
        creative_type: [],
        os: [],
        dsp: [],
        size: [],
        source: '',
        ftx_slot_id: []
      };
      this.refreshData();
    },
    queryList() {
      let condition = {};
      Object.keys(this.form).forEach(key => {
        if (this.form[key]) {
          if (Array.isArray(this.form[key])) {
            condition[key] = this.form[key].map(item => item.value).join(',');
          } else {
            condition[key] = this.form[key];
          }
        }
      });
      this.$store.commit('material/update', {
        condition
      });
      this.refreshData();
    },
    refreshData() {
      this.handleChangePage(1);
    },
    toggleSelection(id) {
      const index = this.selection.indexOf(id);
      if (index >= 0) {
        this.selection.splice(index, 1);
      } else {
        this.selection.push(id);
      }
    },
    clearSelection() {
      this.selection = [];
    },
    getType(id) {
      return this.selection.indexOf(id) >= 0 ? 'primary' : 'default';
    }
  }
};
</script>

<style lang="scss" scoped>
.button {
  margin: 0;
  margin-right: 8px;
  margin-bottom: 10px;
}

.search {
  flex: none;
  padding-bottom: 8px;
  > label {
    width: 100px;
  }
  > .fields {
    display: flex;
    .field {
      display: inline-block;
      margin-right: 8px;
    }
  }
}
.filter {
  flex: none;
  padding-bottom: 25px;
  > label {
    width: 100px;
  }
  > .fields {
    display: flex;
    .field {
      display: inline-block;
      margin-right: 8px;
    }
  }
}
.dialog {
  width: 100%;
  text-align: center;
}

.item {
  margin-bottom: 20px;
  border-radius: 4px;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.04);
  border: solid 1px #e9edf0;
  overflow: hidden;
  .info {
    padding: 13px 16px;
    max-width: 198px;
    box-sizing: border-box;
    background: #f4f6f8;
    display: flex;
    flex-direction: column;
    .name {
      font-size: 12px;
      font-weight: 500;
      letter-spacing: -0.33px;
      color: rgba(0, 0, 0, 0.35);
      display: inline-block;
      min-height: 17px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .size {
      font-size: 14px;
      font-weight: 500;
      letter-spacing: -0.39px;
      color: rgba(0, 0, 0, 0.65);
    }
  }
  .content {
    width: 198px;
    height: 200px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    > :global(div) {
      flex: 1;
      position: relative;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 12px 14px;

      > :global(img) {
        max-width: 100%;
        max-height: 100%;
      }
    }
    > :global(svg) {
      width: 100%;
      height: auto;
    }
  }
}
.mask-wrap {
  position: relative;
  .mask-item {
    display: none;
    cursor: pointer;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0.7),
      rgba(0, 0, 0, 0.4)
    );
    position: absolute;
    top: 0;
    z-index: 2000;
    justify-content: center;
    align-items: center;
    .button {
      color: #fff;
      text-align: center;
      width: 28px;
      height: 28px;
      border-radius: 50%;
      background: rgba(0, 0, 0, 0.6);
      display: inline-block;
      font-size: 16px;
      display: flex;
      justify-content: center;
      align-items: center;
      &:hover {
        background: #3fb7ff;
      }
      &.center {
        margin: 0 14px;
      }
      &.big {
        height: 48px;
        width: 48px;
        font-size: 23px;
      }
    }
  }
  &:hover {
    .mask-item {
      display: flex;
    }
  }
}
.cl-pagination {
  padding-bottom: 0;
}
</style>
